import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const ArrowDown = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    // @ts-ignore
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M6 9L12 15L18 9"
      stroke={props.stroke ? props.stroke : 'black'}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
export default ArrowDown;
